import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { EventEmitter } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";

@Component({
  selector: "app-reopen-form-dialog",
  templateUrl: "./reopen-form-dialog.component.html",
  styleUrls: ["./reopen-form-dialog.component.scss"],
})
export class ReopenFormDialogComponent implements OnInit {
  onConfirm = new EventEmitter();

  projectId: string = "";
  projectData: any = {};

  reasonControl = new FormControl("", Validators.required);
  reasonOtherControl = new FormControl("");

  reasonOptions = [
    { value: "late_invoicing", label: "Late invoicing" },
    { value: "retainage", label: "Retainage" },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ReopenFormDialogComponent>
  ) {}

  ngOnInit() {
    this.projectId = this.data.projectId || "";
    this.projectData = this.data.project || {};
  }

  closeDialog() {
    this.dialogRef.close();
  }

  confirmReopen() {
    if (this.reasonControl.invalid) {
      this.reasonControl.markAsTouched();
      return;
    }

    this.onConfirm.emit({
      confirmed: true,
      reason: this.reasonControl.value,
      reasonOther: this.reasonOtherControl.value,
      projectData: this.projectData
    });
    this.dialogRef.close();
  }
}
